<app-header [forceLightBackground]="true"></app-header>
<div class="delegate-page">
  <div class="delegate-page--layout">
    <app-consumer-sidebar class="delegate-page--sidebar"></app-consumer-sidebar>
    <div class="delegate-page--content">
      <app-page-header></app-page-header>
      <div class="delegate-container">
        <lib-manage-delegates
          tabStorageScope="consumer"
          [ownersOnly]="ownersOnly"
          [activeOwnerId]="activeDelegatedOwnerId"
          [scopeOptions]="consumerScopeOptions"
          (addDelegate)="onDelegateCreated()"
          (deleteDelegate)="onDelegateDeleted()"
          (withdrawOwner)="onAccessRevoked($event)"
          (switchOwner)="onSwitchOwner($event)"
          (requestOwner)="onRequestOwner($event)"
        ></lib-manage-delegates>
      </div>
    </div>
  </div>
</div>
